import React from "react";
import { Helmet } from "react-helmet";

const MetaHeader = ({ routeName, flatNumber }) => (
  <Helmet>
    <title>
      {(routeName && `${flatNumber || ""} ${routeName} Restaurants`) ||
        "Restaurants"}
    </title>
    <meta
      property="og:title"
      content={(routeName && `${routeName} Restaurants`) || "Restaurants"}
    />
  </Helmet>
);

export default MetaHeader;
